// extracted by mini-css-extract-plugin
export default {"loadercontainer":"Loader_loadercontainer__s2riU","loader":"Loader_loader__RbhVF","spin":"Loader_spin__jTe9y"};